<template>
  <div class="container">
    <div class="payment-container">
      <!-- The Adyen.Web `.mount(...)`-function will target this div element -->
      <div id="component-container" class="payment"></div>
    </div>
  </div>
</template>

<script>
import { AdyenCheckout, GooglePay } from '@adyen/adyen-web';
import '@adyen/adyen-web/styles/adyen.css';

export default {
  data() {
    return {
      stripe: null,
      clientSecret: null,
      elements: null,
      amount: null,  // 从 URL 查询参数中获取传入的 amount
      encryptedString: this.$route.params.encryptedString,  // 从 URL 获取加密串
      orderId: null, // 从 URL 查询参数中获取传入的 orderId
      payType: null,
      errorMsg: null,
      returnUrl: null,
      wayCode: null,
      platformWebsite: null,
      randomNo: null
    };
  },
  async mounted() {
    document.title = 'Payment Center';
    try {
      const globalConfiguration = {
        session: {
          id: 'CS8B9DBEDECD323F604F94298', // Unique identifier for the payment session.
          sessionData: 'Ab02b4c0!BQABAgBzXUgZyGIFp7wq6eFfzkL+oAUDZHgR3/ZTvBLN5RD/Jj2AiUiiQmA8B3MIzjtiGvLXTkUayuqA1sVidAPo/50tVOUj0hwmtXchWlkxJSrn3212ea9Uu69qbTfSS5JmFJ4ShyM9kCSGcPKD5cDpaqnIWwnyboEcH7M4BL/FmLwGAqhqCN0BETQyI32VzMtZt15ALPLsc2ZZPni5Ig/YHlRMCYDdd80PTA596fj/6GL1Jd3QRIjXTGhATW7+MkxrkfYl85y9zPQs6vRdU8kJTLAhDbC0w9qvAfbDe45G494+NUbIkTdGoA6dr1gPPHxXtr+PFGWHnXj6oJRnmNWykVGecUke6IyhmFCbJRmEdGV2J6U4Czx/3aUJGxtyDYE+cXo8lDQuv/saMZCCA8SwK8bDEqmBnOdcWnbMze1pO1uf0g8bpV53fYGmUoIRa97TL+mL1rarBmAd5izOV4ajvXWPsXscC2WMlUmPTgnHfjn2JlQg6h6Ait920YpMscL9HO2v5iWgQ1fEEhrWQ0Nnu30rlgWtSLdtn6P96p7r8qQpG5ALoiaZG558AkHTXt2ixb6OWRd8TlmEk8hhAqy8GX0qs+fKq+7j8O8deOdL0sISKRNEY32Gmu+D6Km0bZ6C8vDmkskbQXbmsA8oBy7xnHGiUec8j4olpGLkq6wRzVOyngzkJUE/gqibK+a1pngASnsia2V5IjoiQUYwQUFBMTAzQ0E1MzdFQUVEODdDMjRERDUzOTA5QjgwQTc4QTkyM0UzODIzRDY4REFDQzk0QjlGRjgzMDVEQyJ9oF+zRjidAvxUWAqpatQ0x/Vwc+AF02yHRHzdCQZg0bA+iLqz0KZ47b7C20h/0fAWz8qzPro4J1YPmASCynaGf5H0gFDlmKs/pZszDybhYSDoamBqdj2jrcrM6KDDqE+wNpDoL8axKW8F45+NKc9yYhWGLxpzZ9WfqZlYgclZK912mU+yEcWTTg3ML1ab4OL1pcjF9bYedBACgzmskLCod0GC5EmW6g+jCjgUnOqWLmnkREyeWSFNFcessu1I6Oodxn0UyO9CydMQkk/rW0WCaOAuBzZ0b1zluwcT6E8n6MWAjXEifqS3RET8S1BXPhBdzX1vwItUY600xYW4N4MkG2RYD79GEVk6RUh9UunzhX5hEA43twndJTGwoMauNPVmd0k1UqLb9lLNWRnLJZe62KEFlzoRu/eyf7zdX522kX6POqFsOa/tmDC73wczQzG5PFoAiW2mpahYLjgMEbApFqZ3mWVmRmp2nG7syBQTTrdf7eyo34EgTpzLhhbYIl7uBEzK5gPHc2q4hrP9mZ1IdJF+h7n5T5WMov9TtrzC3g1f6NNETqSg9ysPLWzuuPMVTnMYqDD5FlGPMlZ/FNp6cgleatr4pqkvyac88YDh/KuQkhlJx/TQSIPm8ZgdPbe3xvRomsZDVrTh5atd4aa32IH1nspr6MR3V3WM3uU=' // The payment session data.
        },
        environment: 'test', // Change to 'live' for the live environment.
        amount: {
          value: 1000,
          currency: 'USD'
        },
        locale: 'en-US',
        countryCode: 'NL',
        clientKey: 'test_DEIVWJVALFBV3JNHZ6YGZKHMCYUNPXNR', // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        onPaymentCompleted: (result, component) => {
          console.info(result, component);
        },
        onPaymentFailed: (result, component) => {
          console.info(result, component);
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
        }
      };
      const checkout = await AdyenCheckout(globalConfiguration);
      const dropin = new GooglePay(checkout, globalConfiguration).mount('#component-container');

      console.log('dropin', dropin);

    } catch (error) {
      console.error('error', error);
    }
  },
  methods: {
    async handleCashappPaymentAuto() {

    }
  },
};
</script>
<style scoped>
#myIframe {
  width: 100%;
  height: 100%;
  position: fixed; /* 或者 absolute，取决于你的布局需求 */
  top: 0;
  left: 0;
  z-index: 1000; /* 确保它在其他元素之上 */
}
</style>